import React, {PropTypes} from 'react';

class CalendarTemperatures extends React.Component {

  constructor () {
    super();
    this.calculate_pixel_offset = this.calculate_pixel_offset.bind(this);
  }

  componentDidMount() {
    // Activate Bootstrap tooltips
    $('[data-toggle="tooltip"]').tooltip();
  }

  calculate_pixel_offset (graph_height, metric, min_global, max_global) {
    // Round the input to avoid having several months at "28" with different heights on the graph
    metric = Math.round(metric);
    let pixels_available = graph_height * 0.92;
    let global_span = max_global - min_global;
    let global_variation = (metric - min_global) * (pixels_available / global_span);
    let metric_offset = graph_height - global_variation * 1 - 1;
    return Math.round(metric_offset);
  }

  render () {
    // Define graph height
    let graph_height = 80;
    if (this.props.size === 'small') graph_height = 60;

    // Months
    let monthsTags = [];
    let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    for (let i = 0; i < months.length; i++) {
      let selected = '';
      if (i + 1 == this.props.currentMonth) {
        selected = 'selected';
      }
      monthsTags.push(<th key={i} className={selected}>{months[i]}</th>);
    }

    // Temperatures
    let temperatures = this.props.temperatures;
    let temperaturesTags = [];
    // Go through months
    for (let i = 0; i < temperatures.length; i++) {
      let temperature = temperatures[i];
      // Background color
      let bgColor = "7";
      if (temperature <= 27) {
          bgColor = "6";
      }
      if (temperature <= 20) {
          bgColor = "5";
      }
      if (temperature < 12) {
          bgColor = "4";
      }
      if (temperature < 6) {
          bgColor = "3";
      }
      if (temperature < 0) {
          bgColor = "2";
      }
      if (temperature < -5) {
          bgColor = "1";
      }
      // Background position
      let bgPosition = "center " + this.calculate_pixel_offset(graph_height, temperature, '-15', '34') + "px";
      let divStyle = {
        backgroundImage: 'url(graph-temperature-' + bgColor + '.gif)',
        backgroundPosition: bgPosition
      };
      // Define if this month is selected
      let selected = '';
      if (i + 1 == this.props.currentMonth) {
        selected = 'selected';
      }
      // Push
      temperaturesTags.push(
        <td key={i} style={divStyle}>
          <span key={i} className={selected}>{Math.round(temperature)}</span>
        </td>
      );
    }

    // Title is displayed only for big graphes
    let title;
    if (this.props.size === 'big') {
      title = (
        <tr>
          <td colSpan="12" className="metric-title">Temperatures (°C)</td>
        </tr>
      )
    }

    // Initial width
    let tableStyle = {
      width: this.props.initialWidth
    };

    return (
      <div>
        <div className="calendar-container">
          <table className="calendar" style={tableStyle}>
            <tbody>
              <tr className="precipitations-row">
                {temperaturesTags}
              </tr>
              {title}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

CalendarTemperatures.propTypes = {
  temperatures: PropTypes.array.isRequired,
  size: PropTypes.string.isRequired,
  currentMonth: PropTypes.number.isRequired,
  initialWidth: PropTypes.string.isRequired
};


export default CalendarTemperatures;



/** WEBPACK FOOTER **
 ** ./src/components/CalendarTemperatures.js
 **/